export function SupplierMentionWarning({
    mention,
    override,
    onOverrideChange,
    idPrefix,
}: {
    mention: string | null;
    override: boolean;
    onOverrideChange: (value: boolean) => void;
    idPrefix: string;
}) {
    if (!mention) return null;
    const id = `${idPrefix}-allow-supplier`;
    return (
        <div className="rounded-md border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs text-amber-900 dark:text-amber-200 space-y-1">
            <p>
                El texto nombra al proveedor o distribuidor (<strong>{mention}</strong>). No se publica
                quién nos sirve el producto: quítalo antes de guardar.
            </p>
            <label htmlFor={id} className="flex items-center gap-2 cursor-pointer">
                <input
                    id={id}
                    type="checkbox"
                    checked={override}
                    onChange={(e) => onOverrideChange(e.target.checked)}
                />
                Es correcto, guardar igualmente
            </label>
        </div>
    );
}
